const { AFRAME } = window

AFRAME.registerComponent('scene-settings', {
  dependencies: ['collider-check'],
  init() {
    this.el.setAttribute('cursor', 'rayOrigin: mouse')
    this.el.setAttribute('raycaster', 'objects: [data-button]; near:1; far:12; interval:100;')
  },
})
